export default class Utils {
    static getImage(nomination) {

        let image = ''

        if(nomination.images && nomination.images.length>0 ) {
            image = nomination.images.find((image) => image.default) || nomination.images[0];
            image = image.url.replace("s3.amazonaws.com/", "");

            const filename = image.slice(image.lastIndexOf('/') + 1);
            image = image.replace("/image/", "/thumbs/").replace(filename, `thumb-${filename}`)
        }
        else {
            switch (nomination.medal) {
                case "Oro":
                    image = "./images/OroFIAP.png";
                    break;
                case "Plata":
                    image = "./images/PlataFIAP.png";
                    break;
                case "Bronce":
                    image = "./images/BronceFIAP.png";
                    break;
                default:
                    break;
            }
        }

        return image;
    }

    static removeAccents(string){
        return string.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
}